import type { LocalDate } from '@zg-rentals/ts-customer-analytics-client';

export const localDateToDate = (localDate: LocalDate) => {
  return new Date(localDate.year, localDate.month - 1, localDate.day);
};

export const formatLocalDate = (localDate: LocalDate | undefined): string => {
  if (!localDate) return '';
  const month = String(localDate.month).padStart(2, '0');
  const day = String(localDate.day).padStart(2, '0');
  return `${month}/${day}/${localDate.year}`;
};
